export const INSTAGRAM_URL = "https://www.instagram.com/theehybridperfomanceacademy";
export const WHATSAPP_PHONE_NUMBER = "96171570069";

const formatValue = (value) => {
  if (typeof value === "boolean") {
    return value ? "Yes" : "No";
  }

  return String(value || "").trim();
};

export const openWhatsAppMessage = (title, fields) => {
  const lines = [title, ""];

  fields.forEach(([label, value]) => {
    const formatted = formatValue(value);

    if (formatted) {
      lines.push(`${label}: ${formatted}`);
    }
  });

  const text = encodeURIComponent(lines.join("\n"));
  window.open(`https://wa.me/${WHATSAPP_PHONE_NUMBER}?text=${text}`, "_blank", "noopener,noreferrer");
};